import { Modal, ModalContent, ModalTitle } from "./modal";
import { Switch } from "./ui/switch";
import { useAtom } from "@xoid/react";
import { forceOffline, updateForceOffline } from "@/hooks/use-network-status";
import { Button } from "./ui/button";
import { useFeatureFlags, updateFeatureFlags } from "@/lib/runtime-config";

export function MaintenanceToolsModal() {
  const forceOfflineValue = useAtom(forceOffline);
  const flags = useFeatureFlags();

  return (
    <Modal>
      <ModalTitle>Karbantartó eszközök</ModalTitle>
      <ModalContent>
        <div className="flex gap-2">
          <Switch
            checked={forceOfflineValue}
            onCheckedChange={(checked) => {
              updateForceOffline(checked);
            }}
          />
          <span>Offline állapot szimulálása</span>
        </div>
        <div className="flex gap-2">
          <Switch
            checked={flags.cashPaymentDebug}
            onCheckedChange={(checked) => {
              updateFeatureFlags({ cashPaymentDebug: checked });
            }}
          />
          <span>Eszköz debug mód</span>
        </div>
        {false && (
          <Button
            onClick={() => {
              fetch("http://localhost:3000/note-validator/dispense-latest", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
              });
            }}
          >
            1 db bankjegy kiadása
          </Button>
        )}
      </ModalContent>
    </Modal>
  );
}
